module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/99041652f36815b1702b8bc7f019f625.gif";